module.exports = __webpack_public_path__ + "static/lframe-calculator-personal-loan-repayment-02273a07491a4f857175bd343b6d1f4e.png";